import { render, staticRenderFns } from "./AdditionListItem.vue?vue&type=template&id=36d64e2b&"
import script from "./AdditionListItem.vue?vue&type=script&lang=ts&"
export * from "./AdditionListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports